import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpRightFromSquare, faPhone } from "@fortawesome/free-solid-svg-icons";
import { faGithub, faLinkedin } from "@fortawesome/free-brands-svg-icons";
import Reveal from "../ui/Reveal";
import SectionLabel from "../ui/SectionLabel";
import { profile } from "../../data/profile";

function Contact() {
  return (
    <StyledContact id="contact" aria-labelledby="contact-heading">
      <SectionLabel>Get in touch</SectionLabel>
      <ContactGrid>
        <Reveal as="div">
          <h2 id="contact-heading">
            Have a project in mind?
            <br />
            <em>Let's talk.</em>
          </h2>
          <p>
            I'm open to Software Engineer roles and thoughtful collaborations. My inbox is always the best
            place to start.
          </p>
        </Reveal>
        <Reveal as="div" delay={0.1}>
          <ContactLinks>
            <a href={`mailto:${profile.email}`}>
              {profile.email} <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
            </a>
            <a href={`tel:${profile.phone}`}>
              {profile.phone} <FontAwesomeIcon icon={faPhone} />
            </a>
          </ContactLinks>
          <Socials>
            <a href={profile.github} target="_blank" rel="noreferrer">
              <FontAwesomeIcon icon={faGithub} /> GitHub
            </a>
            <a href={profile.linkedin} target="_blank" rel="noreferrer">
              <FontAwesomeIcon icon={faLinkedin} /> LinkedIn
            </a>
          </Socials>
        </Reveal>
      </ContactGrid>
    </StyledContact>
  );
}

const StyledContact = styled.section`
  background: var(--contact-bg);
  padding: 90px max(28px, calc((100vw - 1184px) / 2)) 100px;
  color: #fff;

  --section-label-color: #fff;

  @media (max-width: 700px) {
    padding: 60px 24px 70px;
  }
`;

const ContactGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 0.8fr;
  gap: 90px;

  h2 {
    font-size: clamp(2.4rem, 5vw, 4rem);
    letter-spacing: -0.03em;
    line-height: 1.05;
    margin: 0;
    color: #fff;
  }

  em {
    font-family: Georgia, serif;
    font-weight: 400;
    font-style: normal;
  }

  p {
    max-width: 450px;
    font-size: 1rem;
    line-height: 1.65;
    margin: 24px 0 0;
    color: rgba(255, 255, 255, 0.9);
  }

  @media (max-width: 760px) {
    grid-template-columns: 1fr;
    gap: 50px;
  }
`;

const ContactLinks = styled.div`
  align-self: end;
  display: flex;
  flex-direction: column;
  gap: 14px;

  a {
    font-size: clamp(1rem, 2vw, 1.35rem);
    font-weight: 700;
    color: #fff;
    text-decoration: none;
    border-bottom: 1px solid rgba(255, 255, 255, 0.6);
    padding-bottom: 10px;
    display: flex;
    justify-content: space-between;
    gap: 15px;
    transition: border-color 0.2s ease;

    &:hover {
      border-color: #fff;
    }
  }
`;

const Socials = styled.div`
  display: flex;
  gap: 21px;
  margin-top: 25px;

  a {
    font-size: 0.85rem;
    color: #fff;
    text-decoration: none;
    font-weight: 700;
    opacity: 0.92;

    &:hover {
      opacity: 1;
      text-decoration: underline;
    }

    svg {
      margin-right: 6px;
    }
  }
`;

export default Contact;
